import React from 'react';
import { makeStyles } from 'react-scale/components/design-system/styles';
import ReactTooltip from 'react-tooltip';
import Markdown from '@scale/frontend-lib/markdown';

const useStyles = makeStyles({
  tooltipInfoIcon: {
    paddingLeft: 8,
    paddingRight: 8,
    color: 'rgba(1, 1, 1, 0.75)',
  },
  tooltipText: {
    maxWidth: 496,
  },
});

const InfoIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M6.9998 0.799805C3.57588 0.799805 0.799805 3.57688 0.799805 6.9998C0.799805 10.4247 3.57588 13.1998 6.9998 13.1998C10.4237 13.1998 13.1998 10.4247 13.1998 6.9998C13.1998 3.57688 10.4237 0.799805 6.9998 0.799805ZM6.9998 3.5498C7.5797 3.5498 8.0498 4.0199 8.0498 4.5998C8.0498 5.1797 7.5797 5.6498 6.9998 5.6498C6.4199 5.6498 5.9498 5.1797 5.9498 4.5998C5.9498 4.0199 6.4199 3.5498 6.9998 3.5498ZM8.3998 9.8998C8.3998 10.0655 8.26548 10.1998 8.0998 10.1998H5.8998C5.73413 10.1998 5.5998 10.0655 5.5998 9.8998V9.2998C5.5998 9.13413 5.73413 8.9998 5.8998 8.9998H6.1998V7.3998H5.8998C5.73413 7.3998 5.5998 7.26548 5.5998 7.0998V6.4998C5.5998 6.33413 5.73413 6.1998 5.8998 6.1998H7.4998C7.66548 6.1998 7.7998 6.33413 7.7998 6.4998V8.9998H8.0998C8.26548 8.9998 8.3998 9.13413 8.3998 9.2998V9.8998Z"
    />
  </svg>
);

const BuilderHint: React.FC<{
  name: string;
  hint: string;
}> = ({ name, hint }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.tooltipInfoIcon} data-tip data-for={`hint-tooltip-${name}`}>
        <InfoIcon />
      </div>
      <ReactTooltip id={`hint-tooltip-${name}`} place="top">
        <div
          className={classes.tooltipText}
          dangerouslySetInnerHTML={{ __html: Markdown.renderInline(hint) }}
        />
      </ReactTooltip>
    </>
  );
};

export default BuilderHint;
